var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"whitespace-nowrap py-1",class:_vm.isFirst ? 'p-1' : 'pl-4',attrs:{"colspan":_vm.colspan}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }